import { parseDateRange } from '../../../helpers/parseDateRange';

export const parseCustomFilters = ({ pagination, filters }) => ({
  pagination,
  reportType: filters.reportType,
  dateRange: parseDateRange(filters.dateRange),
});
